import {getApiUrl} from 'api/urls'
import {apiFetch} from 'lib/fetch'
import type {ListPerson} from 'types/person'

export const list = async (): Promise<ListPerson[]> =>
  apiFetch.get<ListPerson[]>(getApiUrl('persons'), {simple: 'true'})
